import { Axios } from "../httpService";

export const getListAcm = () => {
  return Axios.get("/Info/ListAcm");
};
export const getHistory = () => {
  return Axios.get("/User/ListsanadHistory");
};

export const getRules = () => {
  return Axios.get("/Info/ListGhavanin");
};
export const forgetPass = (phone) => {
  return Axios.get(`/User/ForgetPassword/${phone}`);
};

export const register = (data) => {
  return Axios.post("/User/Register", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const getIp = () => {
  return Axios.post("/User/GetIp",  { name: "" }, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const userLogin = (data) => {
  return Axios.post('/User/Login', data, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,  
  });
};
export const LogOut = () => {
    return Axios.get("/User/LogOut");
  };
  
export const CheckLogin = () => {
    return Axios.get("/User/CheckLogin");
  };
export const GetUserInfo = () => {
    return Axios.get("/User/GetUserInfo");
  };
export const ListsanadHistory = () => {
    return Axios.get("/User/ListsanadHistory");
  };
  
  export const editProfile = (data) => {
    return Axios.put('/User/editProfile', data, {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,  
    });
  };
  export const DeleteSanadHistory = (id) => {
    return Axios.delete(`/User/DeleteSanadHistory/${id}`);
  };
export const DeleteAllSanadHistory = () => {
    return Axios.delete(`/User/DeleteAllSanadHistory`);
  };

  export const ListSanadUser = () => {
    return Axios.get("/User/ListSanadUser");
  };

  export const DeleteSanad = (id) => {
    return Axios.delete(`/User/DeleteSanad/${id}`);
  };
  export const GetSanadByid = (id) => {
    return Axios.get(`/User/GetSanadByid/${id}`);
  };
  export const EditCodePoya = (id) => {
    return Axios.put(`/User/EditCodePoya/${id}`);
  };
  export const listfilesanad = (id) => {
    return Axios.get(`/User/listfilesanad/${id}`);
  };
  export const ListUpdate = () => {
    return Axios.get("/User/ListUpdate");
  };